{
    "languages": [
        { "languageCode": "be", "displayName": "Belarusian" },
        { "languageCode": "ceb", "displayName": "Cebuano" },
        { "languageCode": "ny", "displayName": "Chichewa" },
        { "languageCode": "co", "displayName": "Corsican" },
        { "languageCode": "eo", "displayName": "Esperanto" },
        { "languageCode": "fy", "displayName": "Frisian" },
        { "languageCode": "ht", "displayName": "Haitian Creole" },
        { "languageCode": "ha", "displayName": "Hausa" },
        { "languageCode": "haw", "displayName": "Hawaiian" },
        { "languageCode": "hmn", "displayName": "Hmong" },
        { "languageCode": "ig", "displayName": "Igbo" },
        { "languageCode": "ku", "displayName": "Kurdish (Kurmanji)" },
        { "languageCode": "ky", "displayName": "Kyrgyz" },
        { "languageCode": "la", "displayName": "Latin" },
        { "languageCode": "lb", "displayName": "Luxembourgish" },
        { "languageCode": "mg", "displayName": "Malagasy" },
        { "languageCode": "mi", "displayName": "Maori" },
        { "languageCode": "no", "displayName": "Norwegian" },
        { "languageCode": "sm", "displayName": "Samoan" },
        { "languageCode": "gd", "displayName": "Scots Gaelic" },
        { "languageCode": "st", "displayName": "Sesotho" },
        { "languageCode": "sn", "displayName": "Shona" },
        { "languageCode": "sd", "displayName": "Sindhi" },
        { "languageCode": "su", "displayName": "Sundanese" },
        { "languageCode": "tg", "displayName": "Tajik" },
        { "languageCode": "xh", "displayName": "Xhosa" },
        { "languageCode": "yi", "displayName": "Yiddish" },
        { "languageCode": "yo", "displayName": "Yoruba" }
    ]
}